export const styles = {
  modal: {
    '& .MuiDialog-paper': {
      width: 650,
      maxWidth: '650px',
      padding: '40px 0 20px',
      borderRadius: 2,
      overflow: 'auto',
      backgroundColor: '#fff',
    },
    '& .MuiDialogActions-root': {
      justifyContent: 'center',
      height: 48,
      padding: 0,
      '& button': { margin: '0 12px' },
    },
  },

  container: {
    px: 5,
    py: 2.5,
  },

  content: {
    width: '100%',
  },

  variantChoicesLabel: {
    marginBottom: '22px',
    fontFamily: 'Inter',
    fontSize: '14px',
    lineHeight: '146%',
  },
};
